import React, { forwardRef } from 'react';
import cn from 'classnames';
import "./Price.css";
var styles = { "general": "ac3d9e", "original-normal": "c04eed", "original-large": "e98f30", "black-normal": "aeecde", "black-large": "edbe20", "previous-meta-normal": "dc748a" };
const Price = forwardRef(({ Tag = 'p', children, size = 'normal', type = 'black', hasDataTrackingPii, className, testId }, ref) => {
    return (React.createElement(Tag, { className: cn(styles[`${type}-${size}`], styles.general, className), "data-tracking-pii": hasDataTrackingPii, "data-testid": testId, ref: ref }, children));
});
export default Price;
//# sourceMappingURL=Price.js.map